import React, { useEffect, useState } from 'react';
import DotsLoader from '../Loader/DotsLoader/DotsLoader';
import { BI_ACTION_SHEET_HEADING, BI_LOADING_TEXT } from '../../utils/messageText';
import LanguageTranslater from '../HOC/LanguageTranslater';
import ActionSheetModal from '../PolicySpecficQuestions/ActionSheetModal/ActionSheetModal';

const options = {
    cMapUrl: 'cmaps/',
    cMapPacked: true,
    standardFontDataUrl: 'standard_fonts/',
};


const BenefitIllustration = ({ BIAttempts, setGetBIAttempts, pdfUrl, setIsViewLoaded, translate, isSDPage, closePage }) => {

    const [mounted, setMounted] = useState(false)
    const [loading, setLoading] = useState(false)
    const [showPdf, setShowPdf] = useState(false)
    const [docWidth, setDocWidth] = useState(document.documentElement.clientWidth - 6)
    const [showActionSheet, setShowActionSheet] = useState(false)

    useEffect(() => {
        const mountComponent = () => {
            setLoading(true)
            window.pdfjsLib.getDocument(pdfUrl).promise.then(pdf => {
                console.log(`PDF loaded — ${pdf.numPages} pages`);
                const viewer = document.querySelector('.biPageContent');
                for (let pageNum = 1; pageNum <= pdf.numPages; pageNum++) {
                    pdf.getPage(pageNum).then(page => {
                        const canvas = document.createElement('canvas');
                        const context = canvas.getContext('2d');
                        viewer.appendChild(canvas);
                        const containerWidth = viewer.clientWidth - 6;
                        const viewport = page.getViewport({ scale: 1 });
                        const scale = containerWidth / viewport.width;
                        const scaledViewport = page.getViewport({ scale: 0.8 });
                        console.log(viewer.clientHeight, {scale}, {scaledViewport})
                        canvas.width = scaledViewport.width;
                        canvas.height = viewer.clientHeight;
                        const renderContext = {
                            canvasContext: context,
                            viewport: scaledViewport
                        };
                        page.render(renderContext).promise.then(() => {
                            console.log(`Rendered page ${pageNum}`);
                        });
                    });
                }
                setIsViewLoaded(true)
            }).catch(err => {
                console.error('Error loading PDF:', err);
                handleErr(err)
            }).finally(() =>{
                setLoading(false)
            });
        }
        if (!mounted) {
            mountComponent()
            setMounted(true)
        }
    }, [mounted])

    const handleErr = (err) => {
        console.log("Err : ", err)
        console.log("Attempt Err : ", BIAttempts)
        if(isSDPage) {
            setShowActionSheet(true)
        }
        if(BIAttempts < 3) {
            setGetBIAttempts((prev) => prev + 1)
        }
    }

    if (loading) {
        return <DotsLoader msg={translate(BI_LOADING_TEXT)} />
    }
    return (
        <div>
            <canvas id="pdf-canvas"></canvas>
            {isSDPage && (!pdfUrl || showActionSheet)&& <ActionSheetModal
                heading={translate(BI_ACTION_SHEET_HEADING)}
                description={""}
                modalType={"BI_Failed"}
                buttons={[
                    {
                        text: "Close",
                        action: closePage
                    }
                ]}
            />}
        </div>
    );
}

export default LanguageTranslater(BenefitIllustration);